/**
 * Texts for User Training page - Czech
 */
export const userTrainingPageText = {
    title: 'Uživatelské školení - CamAPS FX',
    titleMeta: 'Komplexní školicí materiály pro uživatele CamAPS FX',
    descriptionMeta: 'Přístup ke kompletním školicím materiálům, video návodům, uživatelským příručkám a webinářům, které vám pomohou získat maximum z CamAPS FX.',
    keywords:
        'camaps fx uživatelské školení, camaps školení, školení diabetes, školení inzulínové pumpy, uživatelská příručka, video návody',
    localeMeta: 'cs_cz',

    mainHeader: 'Uživatelské školení',
    mainSubHeader: 'Dokončete důležité školení v aplikaci před použitím aplikace CamAPS FX.',

    gettingStartedHeader: 'Začínáme',
    step1Title: '<strong>Krok 1:</strong><br/>Stáhněte si aplikaci',
    step2Title: '<strong>Krok 2:</strong><br/>Vytvořte účet',
    step3Title: '<strong>Krok 3:</strong><br/>Začněte důležité školení v aplikaci',
    step4Title: '<strong>Krok 4:</strong><br/>Spárujte se svou zvolenou pumpou a CGM (se souhlasem vašeho zdravotnického týmu) nebo prozkoumejte aplikaci ve <strong>virtuálním režimu</strong>',
    videoSrc: '/video/In-app training loop_1.mp4', // Path to video in public folder

    supportSectionTitle: 'Potřebujete pomoc s instalací aplikace?',
    supportSectionText: 'Navštivte naši sekci podpory pro návod',
    supportButtonText: 'PODPORA',
    findOutMoreButtonText: 'ZJISTIT VÍCE',

    additionalResourcesTitle: 'Další zdroje',
    additionalResourcesSubtitle: 'Učte se pomocí podrobných vizuálů nebo sledujte odborné relace o používání aplikace.',
    
    animationsTitle: 'Animace',
    animationsDescription: 'V současné době je inzulínová pumpa Dana komerčně dostupná pouze s aplikací CamAPS FX ve Spojeném království. Všechny zdroje související s pumpou Dana jsou proto k dispozici pouze v angličtině.',
    animationsLink: 'https://www.camdiabtraining.com/view/27/mylife-YpsoPump-users.htm',
    
    webinarsTitle: 'Webináře',
    webinarsDescription: 'Tyto webové semináře jsou užitečné pro lidi s diabetem 1. typu, jejich rodiny a pečovatele, stejně jako pro učitele, podpůrný personál ve vzdělávání a zdravotníky. Jsou nabízeny v angličtině.',
    webinarsLink: 'https://www.camdiabtraining.com/view/20/Webinars.htm',
    
    factsheetsTitle: 'Informační listy',
    factsheetsDescription: 'V současné době je inzulínová pumpa Dana komerčně dostupná pouze s aplikací CamAPS FX ve Spojeném království. Všechny zdroje související s pumpou Dana jsou proto k dispozici pouze v angličtině.',
    factsheetsLink: 'https://www.camdiabtraining.com',

    inAppTrainingHeader: 'Školení v aplikaci',
    inAppTrainingText: 'Začněte se základním školením integrovaným v aplikaci CamAPS FX. Toto interaktivní školení vás provede všemi klíčovými funkcemi, které potřebujete znát.<br/><br/><strong>Přístup:</strong> Stáhněte si aplikaci CamAPS FX a vytvořte účet pro zahájení školení v aplikaci.',

    gettingStartedText: '<strong>Krok 1:</strong> Stáhněte si aplikaci CamAPS FX z obchodu s aplikacemi vašeho zařízení<br/><strong>Krok 2:</strong> Vytvořte si účet<br/><strong>Krok 3:</strong> Dokončete školicí moduly v aplikaci<br/><strong>Krok 4:</strong> Připojte svou inzulínovou pumpu a CGM<br/><strong>Krok 5:</strong> Začněte svou cestu s CamAPS FX',

    trainingResourcesHeader: 'Další školicí materiály',
    videoTutorialsText: 'Video návody',
    videoTutorialsDesc: 'Sledujte podrobné video průvodce pokrývající nastavení, denní používání a řešení problémů.',
    videoTutorialsLink: 'https://www.camdiabtraining.com/view/20/Webinars.htm',
    
    userGuidesText: 'Uživatelské příručky a dokumentace',
    userGuidesDesc: 'Stáhněte si komplexní PDF příručky a rychlé referenční materiály.',
    userGuidesLink: 'https://www.camdiabtraining.com',
    
    webinarsText: 'Online semináře',
    webinarsDesc: 'Připojte se k školicím sezením vedeným odborníky a možnostem otázek a odpovědí.',

    needHelpHeader: 'Potřebujete pomoc?',
    needHelpTextStart: 'Pokud potřebujete pomoc nebo máte otázky, navštivte naši stránku',
    supportLinkText: 'Podpora',
    needHelpTextEnd: 'pro další pomoc a kontaktní informace.'
};

